import React from 'react';
import { motion } from 'framer-motion';
import { InfinityIcon, UserRoundCheckIcon, MessagesSquareIcon, BrainIcon, TrophyIcon, MessageCircleIcon, PlaneIcon, VideoIcon, UsersRoundIcon, BriefcaseBusinessIcon } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { academySteps } from '../data/academySteps';
import { Sparkle } from '../components/Sparkle';
import { useSeo } from '../hooks/useSeo';
const stepIcons = [InfinityIcon, UserRoundCheckIcon, MessagesSquareIcon, BrainIcon, TrophyIcon, MessageCircleIcon, PlaneIcon, VideoIcon, UsersRoundIcon, BriefcaseBusinessIcon];
export function Ablauf() {
  useSeo({
    title: 'Ablauf der Academy | Hot Sales Girls Academy',
    description: 'Schritt für Schritt zum Erfolg: So läuft die Hot Sales Girls Academy ab – von den Grundlagen im Closing über wöchentliche Live-Trainings bis zur Begleitung in deinen Remote Job.',
    path: '/ablauf'
  });
  return <div className="min-h-screen w-full overflow-x-hidden" data-id="element-412" data-mp="rso54w2xef62">
      <div className="pink-panel relative" data-id="element-413" data-mp="rthcnz9pl8p9">
        <div className="relative z-10" data-id="element-414" data-mp="n1pkjkawmux0">
          <Navbar data-id="element-415" data-mp="n0o4t2iy1k8y" />

          <main className="relative w-full bg-cream px-4 pb-14 pt-6 sm:px-6 sm:pb-20 sm:pt-8" data-id="element-416" data-mp="mzux9zc5uqpr">
            <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-417" data-mp="i2mf3yr0imoi" />
            <span aria-hidden="true" className="gold-glitter-extra" data-id="element-418" data-mp="d4ktp7646b9v" />
            <div className="relative z-10 mx-auto max-w-[1300px]" data-id="element-419" data-mp="846wkk61wlqm">
              <header className="text-center" data-id="element-420" data-mp="871fu8dbw0ig">
                <span className="mb-6 block text-[11px] font-semibold uppercase tracking-[0.25em] text-hot-500" data-id="element-421" data-mp="444s638xle7n">
                  Schritt für Schritt
                </span>
                <div className="relative inline-block" data-id="element-422" data-mp="1ygurj0i2jfmf">
                  <Sparkle className="animate-sparkle-delayed bottom-1 right-[3.75rem] h-8 w-8 sm:-right-8 sm:-top-4 sm:bottom-auto sm:h-10 sm:w-10 md:bottom-1 md:right-[28%] md:top-auto lg:-right-8 lg:-top-4 lg:bottom-auto" data-id="element-423" data-mp="1ygctbybuirbv" />
                  <h1 className="font-heading mx-auto max-w-3xl text-3xl font-extrabold uppercase leading-tight text-neutral-900 sm:text-5xl" data-id="element-424" data-mp="2hdd1laf0xgs2">
                    Schritt für Schritt zum Erfolg
                  </h1>
                </div>
                <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-neutral-600 sm:text-base" data-id="element-425" data-mp="28m4bso71ba57">
                  Das erwartet dich in den 8 Wochen – und weit darüber hinaus.
                </p>
              </header>

              {/* Design 3: Karten-Raster mit riesiger Ziffer als Wasserzeichen. */}
              <ol className="mt-12 grid gap-5 sm:mt-16 sm:grid-cols-2 sm:gap-6 lg:mt-20 lg:gap-7" data-id="element-426" data-mp="2mby27ay6u2h1">
                {academySteps.map((step, index) => {
                const Icon = stepIcons[index];
                return <motion.li key={step.number} initial={{
                  opacity: 0,
                  y: 16
                }} whileInView={{
                  opacity: 1,
                  y: 0
                }} viewport={{
                  once: true,
                  margin: '-60px'
                }} transition={{
                  duration: 0.4,
                  delay: index % 2 * 0.05,
                  ease: [0.23, 1, 0.32, 1]
                }} className="group relative flex h-full flex-col overflow-hidden rounded-[28px] border border-gold/25 bg-white/75 p-6 shadow-sm backdrop-blur-[2px] transition-transform duration-200 ease-out hover:-translate-y-1 sm:p-8" data-id="element-427" data-mp="1azng1ndy94lk" data-mpi={index}>
                      {/* Riesige Ziffer als dezentes Wasserzeichen */}
                      <span aria-hidden="true" className="font-numeral pointer-events-none absolute -right-2 -top-6 select-none text-[110px] font-black leading-none text-gold/15 sm:-right-3 sm:text-[140px]" data-id="element-428" data-mp="yg01qkz52c2p">
                        {step.number}
                      </span>

                      <span className="relative mb-5 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-hot-50" data-id="element-429" data-mp="emjqpr6zrzwb">
                        <Icon className="h-5 w-5 text-hot-500" aria-hidden="true" data-id="element-430" data-mp="jlwf4gdihf10" />
                      </span>

                      <h2 className="font-heading relative text-lg font-bold leading-snug text-neutral-900 sm:text-xl" data-id="element-431" data-mp="oiwksq6g8frl">
                        {step.title}
                      </h2>

                      <span aria-hidden="true" className="relative mt-4 block h-px w-10 bg-gold/50" data-id="element-432" data-mp="xbq3kxl3txa7" />

                      <p className="relative mt-4 text-sm leading-relaxed text-neutral-600" data-id="element-433" data-mp="17afmmtoqlns1">
                        {step.text}
                      </p>
                    </motion.li>;
              })}
              </ol>
            </div>
          </main>

          <Footer data-id="element-434" data-mp="3e15ctz1xguok" />
        </div>
      </div>
      <CookieBanner data-id="element-435" data-mp="3e1y9u8b345ti" />
    </div>;
}